import GLightbox from 'glightbox'
import "glightbox/dist/css/glightbox.css";
export default {
  data() {
    return {
      Slider: null,
      Slide: 1,
      LightBox: null,
    }
  },
  beforeUnmount() {
    if (this.LightBox) {
      this.LightBox.destroy();
    }
  },
  computed: {
    slidesLightBox: function () {
      const typeMapper = {
        'youtube': 'video',
        'url': 'video',
        'vimeo': 'video',
        'upload': 'image'
      }
      return this.slides.map(slide => ({
        href: slide.type === 'youtube' ? slide.url : slide.upload ? slide.upload.url_large : null,
        type: typeMapper[slide.type]
      }))
    }
  },
  methods: {
    slideShowItemClicked(index) {
      this.Slide = index +1
      if (this.LightBox) {
        this.LightBox.destroy();
        this.LightBox = null;
      }
      this.LightBox = GLightbox({
        elements: this.slidesLightBox,
        touchNavigation: true,
        loop: true,
        autoplayVideos: true,
        startAt: index
      })
      this.LightBox.open()
    }
  }
}
